import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__en-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    description:
      'Review Lemonade’s Terms of Service for the Netherlands to learn about the terms, user responsibilities, and conditions for using our platform.',
  },
  MDXContent: content as DocumentTypes,
};
